import { RouteConfig } from "@abaco/web-common/src/app";

const routes: RouteConfig[] = [
    {
        name: "risk-analyses",
        path: "/risk-analyses",
        component: () => import("./components/RiskAnalysesTileContainer.vue"),
        props: { tileId: "risk-analyses-tile" },
        meta: { navbarItems: ["s-c-leader-select-nav-bar-item", 'farm-select-nav-bar-item', "campaign-select-nav-bar-item"] },
    },
    {
        name: "risk-analyses-summary",
        path: "/risk-analyses-summary",
        component: () => import("./components/RiskAnalysesTileContainerSummary.vue"),
        meta: { navbarItems: ["s-c-leader-select-nav-bar-item", 'farm-select-nav-bar-item', "campaign-select-nav-bar-item"] },

    }
];

export default routes;
